//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	
	angular.module("pphhApp")
	.controller("directiveIndexController", ["$scope", "$window", "CommonCatalogService", "pphhEnv", DirectiveIndexController]);
	
	function DirectiveIndexController($scope, $window, commonCatalogService, pphhEnv) {
		
		var MODULE_INDEX = {
			"wbm": 1,
			"pi": 2,
			"qeco": 3,
			"dma": 4,
			"oma": 5,
			"ac": 6,
			"eco": 7,
			"pdm": 8,
			"pom": 9,
			"oig": 10,
			"nid": 11,
			"uww": 12,
			"aru": 13
		};
		
		$scope.directives = [];
		$scope.directivesGroups ={};
		
		$scope.init = init;
		$scope.gotoWaterModule = gotoWaterModule;
		$scope.getGroups = getGroups;
		$scope.showModule = showModule;



		function init(directiveName) {
			commonCatalogService.getDirectives()
			.then(function (directiveArray) {
				directiveArray.sort(function (a, b) {
					if (a.name === "dma_directive") {
						return -1;
					} else {
						return 1;
					}
				});

				angular.forEach(directiveArray, function (directive) {
					sortModules(directive.modules);
				});

				angular.forEach(directiveArray, function (directive) {
					if ((directiveName && directive.name === directiveName)
							|| (!directiveName && directive.name === "dma_directive")) {
						directive.active = true;
					}

					$scope.directives.push(directive);
				});
			});
		}

		function sortModules(modules) {
			modules.sort(function (a, b) {
				var index1 = MODULE_INDEX[a.key];
				var index2 = MODULE_INDEX[b.key];
				if(index1 && index2) {
					return index1 - index2;
				} else if(a.key < b.key) {
					return -1;
				} else if(a.key > b.key) {
					return 1;
				} else {
					return 0;
				}
			});
		}
		function gotoWaterModule(waterModule) {
			var url = pphhEnv.global.contextPath + "/pphh-sgpusa-init?wm=" + waterModule.key;
			$window.location.href = url;
		}
		function getGroups ( directive ){
			// Guardamos los grupos en un array en el scope para no disparar continuamente los eventos de cambios.
			let groupsArray=  $scope.directivesGroups[directive.name];
			// Si no se han calculado los grupos para la directiva, se procede a su calculo.
			if ( !angular.isDefined(groupsArray)){
				groupsArray = [];
				let groups = {};
				angular.forEach(directive.modules, function(module) {
					angular.forEach(module.groups, function (group){
						let currentGroup = groups[group.name];
						if (!angular.isDefined(currentGroup)) {
							groups[group.name] = group;
						}
					});
				});
				angular.forEach(groups, function(group) {
					groupsArray.push(group);
				});
				// Ordenamos los grupos
				groupsArray.sort(function (a, b) {
						if (a.order < b.order) {
							return -1;
						} else {
							return 1;
						}
					});
				// Si no hay grupos añadimos el por defecto.
				if ( groupsArray.length == 0){
					let defaultGroup = {name:"", descripcion:"", alt:"",order:0};
					groupsArray.push (defaultGroup);
				}
				$scope.directivesGroups[directive.name] = groupsArray;
			}
			return groupsArray;
		}

		function showModule (waterModule, actualGroup ){
			
			let inGroup = true;
			if ( actualGroup.name !== "" ){
				inGroup=false;
				angular.forEach(waterModule.groups, function (grupo){
					if ( grupo.name === actualGroup.name ) inGroup=true;
				});
			}
			
			return waterModule.needsViewer && inGroup;
		}
	}
})();